import storage from '@/utils/storage'

export default {
    setDrawer(state, payload){
        state.drawer = payload
    },

    setDrawerColor(state, payload){
        state.drawerColor = payload
    },

    setAppBarColor(state, payload){
      storage.set('app-bar-color', payload)
      state.appBarColor = payload
    },

    setLoadingScreen(state, payload) {
      state.loadingScreen = payload
    }
}
